<template>
    <div id="mini-widget-app" class>
      <form class="mini-widget" @submit.prevent="findTripsSubmit">
        <productSelectFull />
        <div class="widget-bottom">
          <div class="row">
            <div class="col-sm-12">
              <tripTypeSelect @input="changeTripType" />
            </div>
          </div>
          <div class="row">
            <div class="col-sm-5 col-md-2 no-padding">
              <baseSelect id="origin" :label="$t('from')" defaultvalue="from" :options="origins"
                icon="-icon-after -icon-marker" v-model="trip.from" :aria-required="$t('requiredStation')"
                :errors="filterError('#origin')" :hidelabel="true"/>
            </div>
            <div class="col-sm-5 col-md-2 no-padding">
              <baseSelect id="destination" :label="$t('to')" defaultvalue="to" :options="destinations"
                icon="-icon-after" v-model="trip.to" :aria-required="$t('requiredStation')"
                :errors="filterError('#destination')" :hidelabel="true"/>
            </div>
            <div class="col-sm-4 col-md-2 no-padding">
              <div class="row">
                <div v-if="tripType == 'oneway'" class="clearfix">
                  <datePicker class="datetime col-sm-12 departure-wrapper" name="departure" required="true"
                    :label="$t('departure')" :placeholder="$t('departure')" :errors="filterError('#departure')" :hidelabel="true"/>
                </div>
                <div v-if="tripType == 'roundtrip'" class="clearfix">
                  <datePicker class="datetime col-sm-6 departure-wrapper" name="departure" required="true"
                    :label="$t('departure')" :placeholder="$t('departure')" :errors="filterError('#departure')" :hidelabel="true"/>
                  <datePicker class="datetime col-sm-6 return-wrapper" name="return" required="true" :label="$t('return')"
                    :placeholder="$t('return')" :errors="filterError('#return')" :hidelabel="true"/>
                </div>
              </div>
            </div>
            <div class="col-sm-4 col-md-2 no-padding">
              <fareSelect :errors="filterError('#fares')" :hidelabel="true"/>
            </div>
            <div class="col-sm-3 col-md-3">
                <button type="submit" id="findTrips" class="btn btn-primary">
                  {{ $t("faresbtn") }}
                </button>
                <button @click="resetState" class="btn btn-secondary btn-reset">{{ $t('Reset') }}&nbsp;&nbsp;&nbsp;<i class="fa fa-repeat fa-flip-horizontal"></i>
                </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </template>
  
  <script>
  import { mapState, mapGetters } from "vuex";
  import $ from "jquery";
  //import staticErrorList from "../components/staticErrorList.vue";
  import productSelectFull from "../components/productSelectFull.vue";
  import tripTypeSelect from "../components/tripTypeSelect.vue";
  import baseSelect from "../components/baseSelect.vue";
  //import fromSelect from "../components/fromSelect.vue";
  //import toSelect from "../components/toSelect.vue";
  import datePicker from "../components/datePicker.vue";
  import fareSelect from "../components/fareSelect.vue";
  
  export default {
    components: {
      //staticErrorList,
      productSelectFull,
      tripTypeSelect,
      baseSelect,
      //fromSelect,
      //toSelect,
      datePicker,
      fareSelect,
    },
    data() {
      return {
        errors: [],
        langs: ["en", "fr"],
        submitStatus: null,
        trip: {
          from: "",
          to: "",
          //triptype: "oneway",
          departure: "",
          return: "",
          passengers: [],
        },
      };
    },
    computed: {
      ...mapState([
        "tripType",
        "originId",
        "origins",
        "destinationId",
        "destinations",
        "departure",
        "return",
        "selectedFaresStore",
      ]),
      ...mapGetters(["requiresCompanion", "currentFareString"]),
    },
    mounted() {
      //this.$store.dispatch("resetTrip");
      //this.$store.commit("getProducts");
    },
    created() {
      this.$store.dispatch("getLexicons");
      // this.$store.commit(
      //   "getFromStations",
      //   this.$store.state.current_product._id
      // );
      // this.$store.commit("getFares", this.$store.state.current_product._id);
      // console.log(this.$store.departure);
      // console.log(this.departure);
      // console.log(this.originId);
      // console.log(this.destinationId);
      if (this.departure) {
        // this.trip.from = this.originId;
        // this.trip.to = this.destinationId;
        // this.trip.triptype = this.tripType;
        // // eslint-disable-next-line
        // jQuery("#departure").val(this.departure);
        // Set evaluation so mutations don't change the values as we're settings things back.
        let originId = this.originId;
        let destinationId = this.destinationId;
        let tripType = this.tripType;
        //this.trip.from = originId;
        //this.trip.triptype = tripType;
        this.$store.dispatch("fetchFromStations").then(() => {
          this.$store.dispatch("changeFromStation", originId).then(() => {
            $("#origin").val(originId);
            //this.trip.from = originId;
            this.$store.dispatch("changeToStation", destinationId);
            this.trip.to = destinationId;
  
            $("#destination").val(destinationId);
            $("#departure").val(this.departure);
            if (tripType == "roundtrip") {
              $("#roundtrip").prop("checked", true);
              $("#return").val(this.return);
            }
          });
        });
        this.trip.to = destinationId;
        this.$store.dispatch("modifyTripStations", { originId, destinationId });
      } else {
        this.$store.dispatch("fetchProducts").then(() => {
          // fetchProducts already gets from stations and fares.
          // this.$store.dispatch("fetchFromStations").then(() => {
          //   this.$store.dispatch("fetchFares");
          // });
        });
      }
      if (!this.$cookies.get('keep_veux')) {
        this.$store.dispatch("resetTrip");
        $("#origin").val("from");
        $("#destination").val("to");
        this.$store.dispatch("fetchProducts");
      }
      this.$cookies.set('keep_veux', true, '7d');
    },
    watch: {
      "trip.from": function (tripFrom) {
        this.$store.dispatch("changeFromStation", tripFrom);
        $("#destination").val("to");
      },
      "trip.to": function (tripTo) {
        this.$store.dispatch("changeToStation", tripTo);
      },
    },
    methods: {
      // updateFares: function(selectedFares) {
      //   this.appFares = selectedFares;
      //   this.$store.commit("setFares", selectedFares);
      // },
      // createFreshTripObject() {
      //   const id = Math.floor(Math.random() * 10000000);
      //   return {
      //     id: id,
      //     from: "",
      //     to: "",
      //     triptype: "oneway",
      //     departure: "",
      //     return: "",
      //     passengers: [],
      //   };
      // },
      changeTripType(event) {
        //this.trip.triptype = event;
        this.$store.commit("SET_TRIP_TYPE", event);
      },
      filterError: function (key) {
        let filteredError = this.errors.filter(function (error) {
          return error.key == key;
        });
        return filteredError;
      },
      findTripsSubmit: function () {
        this.errors = [];
        if ($("#origin").val() == "from") {
          this.errors.splice(1, 0, {
            key: "#origin",
            value: this.$t("origin_error"),
          });
        }
        if ($("#destination").val() == "to") {
          this.errors.splice(2, 0, {
            key: "#destination",
            value: this.$t("destination_error"),
          });
        }
        if ($("#departure").val() == "") {
          this.errors.splice(3, 0, {
            key: "#departure",
            value: this.$t("departure_error"),
          });
        }
        if (this.tripType === "roundtrip" && $("#return").val() == "") {
          this.errors.splice(4, 0, {
            key: "#return",
            value: this.$t("return_error"),
          });
        }
        if (
          this.tripType === "roundtrip" &&
          $("#return").val() != "" &&
          $("#return").val() < $("#departure").val()
        ) {
          this.errors.splice(4, 0, {
            key: "#return",
            value: this.$t("return_error"),
          });
        }
  
        if (
          $("#faresDropdown .btn-label").text() == "Passengers" ||
          $("#faresDropdown .btn-label").text() == "Passagers"
        ) {
          this.errors.splice(5, 0, {
            key: "#fares",
            value: this.$t("fares_error"),
          });
        }
  
        if (this.requiresCompanion == true) {
          this.errors.splice(6, 0, {
            key: "#fares",
            value: this.$t("Passenger requires a companion."),
          });
        }
        // let fareString = "";
        // const fareSelections = Object.entries(this.appFares);
        // for (const [fare, count] of fareSelections) {
        //   if (count > 0) {
        //     fareString = fareString + `${fare}:${count},`;
        //   }
        // }
        // fareString = fareString.substring(0, fareString.length - 1);
        let returnDate =
          this.$store.state.tripType === "oneway"
            ? ""
            : "&returnDate=" + this.$store.state.return;
        // eslint-disable-next-line no-unused-vars
        let compiledurl =
          //"https://on.betterez.com/cart/52f862392433e2310400004d/trip-results?productFamily=reservation&productId=" +
          process.env.VUE_APP_BETTEREZ_APP_URL +
          "trips?productId=" +
          this.$store.state.current_product._id +
          "&type=" +
          this.$store.state.tripType +
          "&channel=websales&departureDate=" +
          this.$store.state.departure +
          returnDate +
          "&from=" +
          this.$store.state.originId +
          "&to=" +
          this.$store.state.destinationId +
          "&fares=" +
          this.$store.state.fareString;
        // eslint-disable-next-line no-console
        //console.log(compiledurl);
        //this.$store.commit("setFaresString", fareString);
        // Get Trips
        // this.$store.commit("getTrips", {
        //   productId: this.$store.state.current_product._id,
        //   originId: this.$store.state.originId,
        //   destinationId: this.$store.state.destinationId,
        //   departure: this.$store.state.departure,
        //   fareString: this.$store.state.fareString
        // });
        // Router Navigation after navigation
  
        if (!this.errors.length) {
          this.$store
            .dispatch("fetchTrips")
            .then(() => {
              // console.log("trip type", this.trip.triptype);
              // console.log(
              //   "trip departures length ",
              //   this.$store.state.trips.departures.length
              // );
              // console.log(
              //   "trip returns length ",
              //   this.$store.state.trips.returns.length
              // );
              if (
                this.tripType == "oneway" &&
                this.$store.state.trips.departures.length
              ) {
                window.location = compiledurl;
              } else if (
                this.tripType == "roundtrip" &&
                this.$store.state.trips.departures.length &&
                this.$store.state.trips.returns.length
              ) {
                window.location = compiledurl;
              } else {
                alert(this.$t("no_trips"));
              }
            })
            .catch((error) => {
              // eslint-disable-next-line no-console
              console.log("There was an error fetching trips:", error.response);
            });
        } else {
          $("html, body").animate(
            {
              scrollTop: $("#mini-widget-app").offset().top,
            },
            1000
          );
        }
      },
      resetState() {
        // Clear local storage
        localStorage.clear();
        this.$cookies.remove('keep_veux');
        // Refresh page
        location.reload();
        }
    },
    // eslint-disable-next-line no-unused-vars
    //beforeRouteLeave(to, from, next) {
    // called when the route that renders this component is about to
    // be navigated away from.
    // has access to `this` component instance.
    // this.$store.commit("getTrips", {
    //   productId: this.$store.state.current_product._id,
    //   originId: this.$store.state.originId,
    //   destinationId: this.$store.state.destinationId,
    //   departure: this.$store.state.departure,
    //   return: this.$store.state.return,
    //   fareString: this.$store.state.fareString
    // });
    // setTimeout(next(), 300);
    //}
    // beforeRouteEnter(to, from, next) {
    //   next(vm => {
    //     // access to component instance via `vm`
    //     // Called when modifying trip
    //     vm.$store.commit("resetTrips");
    //     vm.$store.commit("resetFares");
    //     vm.$store.commit(
    //       "setCurrentProduct",
    //       vm.$store.state.current_product._id
    //     );
    //   });
    // }
  };
  </script>
  
  <style lang="scss">
  #mini-widget-app {
    font-family: $font-family-base;
  }
  
  #mini-widget-app {
    label {
      font-weight: 300;
      color: $brand-primary;
    }
  
    .mini-widget {
      border-radius: 5px;
      //box-shadow: 0 0 8px rgba(0, 0, 0, 0.1);
      padding-left: 0;
      padding-right: 0;
    }
  
    .widget-bottom {
      padding: 30px;
      box-shadow: 0px 9px 35px rgba(0, 0, 0, 0.04);
    }
  
    .product-selection {
      overflow: hidden;
      border-top-left-radius: 5px;
      border-top-right-radius: 5px;
      //background-color: $brand-primary;
      font-size: 18px;
  
      .product-list {
        margin-bottom: 0px;
        li{
          padding-left:0px;
          padding-right:1px;
        }
      }
  
      a {
        color: #fff;
        font-family: $font-family-base;
        font-size:18px;
        font-weight: 500;
        background-color: $brand-primary;
        padding: 10px;
        text-decoration: none;
        display: flex;
        align-items: center;
  
        &.active {
          background-color: #fff;
          color: $brand-primary;
        }
  
        &:first-child {
          padding-left: 30px;
          padding-right:20px;
        }
      }
    }
  }
  
  .mini-widget {
  
    #origin,
    #destination {
      position: relative;
    }
  
    .select-origin,
    .select-destination {
      position: relative;
  
      &::after {
        content: "\f0ec";
        position: absolute;
        color: $brand-primary;
        top: 35px;
        right: 15px;
        display: inline-block;
        width: 10px;
        height: 10px;
        font-family: "FontAwesome";
        -moz-osx-font-smoothing: grayscale;
        -webkit-font-smoothing: antialiased;
        display: inline-block;
        font-style: normal;
        font-variant: normal;
        font-weight: 900;
        text-rendering: auto;
        line-height: 1;
      }
  
      .form-control[disabled] {
        opacity: 0.5;
      }
    }
    .select-destination{
      &::after{
        content:'';
      }
    }
  
    .form-control[disabled] {
      //opacity: 0.5;
    }
  
    .datetime {
      position: relative;
    }
  
    #oneway,
    #roundtrip {
      opacity: 0;
    }
  
.no-padding {
      padding: 0px;
    }
  
    input[type="radio"]:checked+label.radio-inline::after {
      position: absolute;
      top: 5px;
      left: 5px;
      width: 15px;
      height: 15px;
      border-radius: 15px;
      background-color: $brand-highlight;
      content: "";
      display: block;
      position: absolute;
    }
  
    label.radio-inline {
      color: #1F2123;
      padding-right: 0px;
      ///font-size: 30px;
      font-weight: 300;
      font-family: $font-family-base;
      position: relative;
      padding-left:35px!important;
  
      &::before {
        position: absolute;
        top: 0px;
        left: 0px;
        content: "";
        border: 2px solid $brand-highlight;
        width: 25px;
        height: 25px;
        display: block;
        border-radius: 20px;
      }
    }
  }
  </style>